$(document).ready(function() {
	var $form = $('.contact-form');
	var $submit = $('#contact-submit');
	var $alert = $('.alert');
	var $alertMessage = $('.alert-message');
	var processing = 0;
	var spinner = null;

	function showAlert(message) {
		$alert.show().find('.alert-message').text(message);
	}

	function startProcessing() {
		processing = 1;
		$submit.html('&nbsp;&nbsp;&nbsp;Processing');
		spinner = new Spinner($.extend(true, {}, DEFAULT_SPIN_OPTS, { color : '#333', scale : 0.20, left : 25, top : 17 })).spin($submit[0]);
	}

	function stopProcessing() {
		spinner.stop();
		$submit.text("Submit");
		processing = 0;
	}

	// send another message
	$('.btn-send-message').on('click', function() {
		$form[0].reset();
		$('#contact-datetime').hide();
		datetime_enabled = false;
		$alert.hide();
		$('.contact-form').show();
		$('.contact-thankyou').hide();
	});

	// show date/time for certain purposes
	var datetime_enabled = false;
	$('#contact-purpose').on('change', function(e) {
		var val = $(this).val();
		if (val === 'Cancellation' || val === 'Booking Change') {
			$('#contact-datetime').show();
			datetime_enabled = true;
		}
		else {
			$('#contact-datetime').hide();
			datetime_enabled = false;
		}
	});
	
	// submit contact
	$form.on('submit', function(e) {
		e.preventDefault();
		if (processing) {
			return;
		}

		startProcessing();
		
		var values = $(this).serializeArray();
		var data = {};
		values.forEach(function(o) {
			data[o.name] = String(o.value||"").trim()
		});

		// reset validation
		$alert.hide();
		$('.is-invalid').removeClass('is-invalid');

		var validate = [ "Name", "Email", "Phone", "Location", "Purpose", "Subject", "Message" ];
		var errors = 0;

		validate.forEach(function(name) {
			if (data[name] !== undefined && data[name].length === 0) {
				$('input[name="' + name + '"],textarea[name="' + name + '"],select[name="' + name + '"]').addClass('is-invalid');
				errors += 1;
			}
		});

		// form should be filled
		if (errors > 0) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'missing fields' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Please fill out the entire form before sending.');
			stopProcessing();
			return;
		}

		// location valid
		if (data['Location'] == "") {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'no location' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Please select a location.');
			stopProcessing();
			return;
		}

		// purpose valid
		if (data['Purpose'] == "") {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'no purpose' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Please select the purpose of your email.');
			stopProcessing();
			return;
		}

		// email valid
		if (!EMAIL_REGEX.test(data['Email'])) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'invalid email' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Your email doesn\'t appear to be valid.');
			stopProcessing();
			return;
		}

		// test phone
		if (/[A-Za-z]/.test(data['Phone'])) {
			if (ENABLE_ANALYTICS) {
				gtag('event', 'failed validation', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'invalid phone' });
			}
			if (typeof hj === 'function') {
				hj('formSubmitFailed');
			}
			showAlert('Your phone number doesn\'t appear to be valid.');
			stopProcessing();
			return;
		}

		$.ajax({
			type     : "post",
			url      : "/api/contact/send",
			data     : data,
			cache    : false,
			dataType : 'json',
			success : function(response) {
				if (response.success === 0) {
					if (ENABLE_ANALYTICS) {
						gtag('event', 'error', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'failed' });
					}
					if (typeof hj === 'function') {
						hj('formSubmitFailed');
					}
					showAlert(response.message);
					stopProcessing();
					return;
				}
				if (ENABLE_ANALYTICS) {
					gtag('event', 'sent', { send_to : 'G-9BF9PSVTG2', event_category : 'contact' });
				}
				if (typeof hj === 'function') {
					hj('formSubmitSuccessful');
				}
				if (typeof fbq !== 'undefined') {
					fbq('track', 'ContactForm', { content_name : 'contact' });
				}

				$('.contact-form').hide();
				$('.contact-thankyou').show();
				stopProcessing();
			},
			error : function(xhr, status) {
				if (ENABLE_ANALYTICS) {
					gtag('event', 'error', { send_to : 'G-9BF9PSVTG2', event_category : 'contact', event_label : 'failed' });
				}
				if (typeof hj === 'function') {
					hj('formSubmitFailed');
				}
				showAlert("There was a connection error. Please try again.");
				stopProcessing();
			}
		});

		return false;
	});
});
